import { render } from "./detail-evaluasi-akademik-pra_pelaksanaan.vue?vue&type=template&id=ab93017e"
import script from "./detail-evaluasi-akademik-pra_pelaksanaan.vue?vue&type=script&lang=js"
export * from "./detail-evaluasi-akademik-pra_pelaksanaan.vue?vue&type=script&lang=js"

import "./detail-evaluasi-akademik-pra_pelaksanaan.vue?vue&type=style&index=0&id=ab93017e&lang=css"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__